export default __webpack_public_path__ + "static/media/type1.a067188d.png";